import Layout from '@/views/other/index.vue'

export const other = [{
  path: '/happy-new-year',
  hidden: true,
  redirect: '/happy-new-year/employee',
  component: Layout,
  children: [{
    path: 'employee',
    name: 'Employee',
    component: () => import('@/views/other/happyNewYear/employee/index'),
    meta: { title: '员工端' }
  }, {
    path: 'admin',
    name: 'Admin',
    component: () => import('@/views/other/happyNewYear/admin/index'),
    meta: { title: '管理员端' }
  }]
}]
